export default `
  mutation deleteProject($id: String!) {
    deleteProject(id: $id) {
        id
        organisationId
    }
  }
`
